import config from 'config';
import axios from 'axios';

const ROOT = config.API_BASE_URL;

class EventConfigurationsService {

  static getAll(options=[], minimal=false) {
    return new Promise((resolve, reject) => {
      let params = options.length == 0 ? '' : '?' + options.map(option => Object.keys(option).map((k, i) => `${k}=${option[k]}`)).join('&');
      axios.get(`${ROOT}event-configurations${params}&minimal=${minimal}`).then((data) => {
        resolve({ eventConfigurations: data.data.content, page: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getEventConfigurationsForGrouping(groupingId) {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}event-configurations/${groupingId}/listAllWithTags`).then((data) => {
        resolve({ eventConfigurations: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static archiveEventConfiguration(eventtConfigurationId) {
    return new Promise((resolve, reject) => {
      axios.patch(`${ROOT}event-configurations/${eventtConfigurationId}/archive`).then((data) => {
        resolve({ eventConfiguration: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static get(eventtConfigurationId, detail=false) {
    return new Promise((resolve, reject) => {
      let detailParms = detail ? '?projection=detail' : '';
      axios.get(`${ROOT}event-configurations/${eventtConfigurationId}${detailParms}`).then((data) => {
        resolve({ eventConfiguration: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static save(eventConfiguration) {
    return new Promise((resolve, reject) => {
      axios.patch(`${ROOT}event-configurations/${eventConfiguration.id}`, eventConfiguration).then((data) => {
        resolve({ eventConfiguration: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static add(eventConfiguration) {
    return new Promise((resolve, reject) => {
      axios.post(`${ROOT}event-configurations`, eventConfiguration).then((data) => {
        resolve({ eventConfiguration: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getCalendar(eventExemptTimes) {
    return new Promise((resolve, reject) => {
      axios.post(`${ROOT}event-configurations/calendarFromExemptTimes`, eventExemptTimes).then((data) => {
        resolve({ calendar: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getWorkflow(workflowConfigurationId) {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}event-configurations/workflows/${workflowConfigurationId}`).then((data) => {
        resolve({ workflowConfiguration: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static createWorkflow(workflowConfiguration) {
    return new Promise((resolve, reject) => {
      axios.post(`${ROOT}event-configurations/workflows`, workflowConfiguration).then((data) => {
        resolve({ workflowConfiguration: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static saveWorkflow(workflowConfiguration) {
    return new Promise((resolve, reject) => {
      axios.patch(`${ROOT}event-configurations/workflows/${workflowConfiguration.id}`, workflowConfiguration).then((data) => {
        resolve({ workflowConfiguration: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static archiveWorkflow(workflowConfigurationId) {
    return new Promise((resolve, reject) => {
      axios.patch(`${ROOT}event-configurations/workflows/${workflowConfigurationId}/archive`).then((data) => {
        resolve({ eventConfiguration: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }
}

export default EventConfigurationsService;
